import React from 'react';
import Code42IncydrMimecastLogoSvg from './Code42IncydrMimecastLogoSvg';

const LogoIcon: React.FC = () => {
  return <Code42IncydrMimecastLogoSvg />;
};

export default LogoIcon;
